export enum BonusPaymentType {
Legal,
Full,
}
